import { useEffect, useRef, useState } from "react";

interface MeasuredChartProps {
  height: number;
  className?: string;
  children: (size: { width: number; height: number }) => React.ReactNode;
}

export function MeasuredChart({ height, className, children }: MeasuredChartProps) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const update = () => {
      const nextWidth = Math.floor(element.clientWidth);
      setWidth((prev) => (prev === nextWidth ? prev : nextWidth));
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={className} style={{ height, minWidth: 0 }}>
      {width > 0 ? children({ width, height }) : null}
    </div>
  );
}
